module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Zfiy3U/tc-custom/9781488004261.jpg?1738328774816",
      "alt": "This image is the cover for the book Her Sheriff Bodyguard"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Sheriff Bodyguard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A delightful and passionate western romance about a courageous Boston suffragette who meets her match in a stubborn Devil with spurs and a badge.” —"), _c('i', [_vm._v("RT Book Reviews")])]), _c('br'), _c('br'), _vm._v("“Ladies unite. Votes for women!” "), _c('br'), _c('br'), _vm._v("Caroline MacFarlane has one mission in life. The pain she experienced at the hands of her father is numbed when she stands on stage and teaches the world that women are just as strong, rational and capable as men! "), _c('br'), _c('br'), _vm._v("But when her safety is threatened, suddenly protective sheriff Hawk Rivera is glued to her side—day and night. This unexpected bodyguard has Caroline’s life in his hands, and she’s surprised to find that Hawk’s commanding presence is not just reassuring, but enticing, too . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lynna Banning\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lynna Banning combines a lifelong love of history and literature into a satisfying career as a writer. In the past she has worked as an editor and technical writer, and has taught English and journalism. An amateur pianist and harpsichordist, Lynna performs on psaltery, harp, and recorders with two medieval music groups and coaches ensembles in her spare time. She lives in Felton, in the Santa Cruz Mountains, with two cats and a very nervous canary.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0